import _classCallCheck from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../../defaultTheme";
import media from "../../utils/mediaQuery";
import { StyledModalFooter } from "../ModalFooter";
import { withModalContext } from "../ModalContext";
export var StyledModalSection = styled.section.withConfig({
  displayName: "ModalSection__StyledModalSection",
  componentId: "sc-1ayrdn8-0"
})(["width:100%;padding:", ";background-color:", ";border-bottom:1px solid ", ";box-sizing:border-box;&:first-of-type{border-top:", ";border-top-left-radius:", ";border-top-right-radius:", ";margin-top:", ";}&:last-of-type{border-bottom:", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";& ~ ", "{margin-top:", ";}&:not(:last-child){border-radius:0;}}", ";"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.orbit.spaceLarge, " ").concat(theme.orbit.spaceMedium);
}, function (_ref2) {
  var theme = _ref2.theme,
      suppressed = _ref2.suppressed;
  return suppressed ? theme.orbit.paletteCloudLight : theme.orbit.paletteWhite;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.paletteCloudNormal;
}, function (_ref4) {
  var suppressed = _ref4.suppressed,
      theme = _ref4.theme;
  return suppressed && "1px solid ".concat(theme.orbit.paletteCloudNormal);
}, function (_ref5) {
  var isMobileFullPage = _ref5.isMobileFullPage;
  return !isMobileFullPage && "9px";
}, function (_ref6) {
  var isMobileFullPage = _ref6.isMobileFullPage;
  return !isMobileFullPage && "9px";
}, function (_ref7) {
  var suppressed = _ref7.suppressed,
      theme = _ref7.theme;
  return suppressed && theme.orbit.spaceLarge;
}, function (_ref8) {
  var suppressed = _ref8.suppressed,
      theme = _ref8.theme;
  return suppressed ? "1px solid ".concat(theme.orbit.paletteCloudNormal) : "0";
}, function (_ref9) {
  var isMobileFullPage = _ref9.isMobileFullPage;
  return !isMobileFullPage && "9px";
}, function (_ref10) {
  var isMobileFullPage = _ref10.isMobileFullPage;
  return !isMobileFullPage && "9px";
}, StyledModalFooter, function (_ref11) {
  var theme = _ref11.theme,
      suppressed = _ref11.suppressed;
  return suppressed && theme.orbit.spaceMedium;
}, media.largeMobile(css(["padding:", ";&:first-of-type{margin-top:", ";}&:last-of-type{& ~ ", "{padding-top:", ";margin-top:0;}}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.orbit.spaceXXLarge;
}, function (_ref13) {
  var suppressed = _ref13.suppressed,
      theme = _ref13.theme;
  return suppressed && theme.orbit.spaceXXLarge;
}, StyledModalFooter, function (_ref14) {
  var suppressed = _ref14.suppressed;
  return !suppressed && "0";
})));
StyledModalSection.defaultProps = {
  theme: defaultTheme
};

var ModalSection =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ModalSection, _React$PureComponent);

  function ModalSection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ModalSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ModalSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "callContextFunctions", function () {
      var _this$props = _this.props,
          setDimensions = _this$props.setDimensions,
          decideFixedFooter = _this$props.decideFixedFooter;

      if (setDimensions) {
        setDimensions();
      }

      if (decideFixedFooter) {
        decideFixedFooter();
      }
    });

    return _this;
  }

  _createClass(ModalSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var setHasModalSection = this.props.setHasModalSection;
      this.callContextFunctions();

      if (setHasModalSection) {
        setHasModalSection();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps !== this.props) {
        this.callContextFunctions();
        var _this$props2 = this.props,
            setHasModalSection = _this$props2.setHasModalSection,
            manageFocus = _this$props2.manageFocus;

        if (setHasModalSection) {
          setHasModalSection();
        }

        if (manageFocus) {
          manageFocus();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var removeHasModalSection = this.props.removeHasModalSection;
      this.callContextFunctions();

      if (removeHasModalSection) {
        removeHasModalSection();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          suppressed = _this$props3.suppressed,
          children = _this$props3.children,
          dataTest = _this$props3.dataTest,
          isMobileFullPage = _this$props3.isMobileFullPage;
      return React.createElement(StyledModalSection, {
        suppressed: suppressed,
        "data-test": dataTest,
        isMobileFullPage: isMobileFullPage
      }, children);
    }
  }]);

  return ModalSection;
}(React.PureComponent);

var DecoratedComponent = withModalContext(ModalSection); // $FlowFixMe flow doesn't recognize displayName for functions

DecoratedComponent.displayName = "ModalSection";
export default DecoratedComponent;